angular.module('metadataFunctionInputs', ['signalview.utils']);
